import React from 'react';
import { Users, Music2, Baby, HandHeart } from 'lucide-react';
import { Card, CardMedia } from '../components/ds/Card';
import { Badge } from '../components/ds/Badge';
import { Reveal, PageHero } from '../components/ds/theme';
import ministrytile from '../assets/images/ministrytile.jpg';
import sundaySchoolBg from '../assets/images/sunday_school_bg.jpg';
import worshipBg from '../assets/images/worship_bg.jpg';
import bibleStudyBg from '../assets/images/bible_study_bg.jpg';
import prayerBg from '../assets/images/prayer_bg.jpg';

const MINISTRIES = [
  { Icon: Users, title: 'Youth Ministry', leader: 'Rev. David Thompson', img: sundaySchoolBg, desc: 'Helping teenagers develop a deep, authentic relationship with Jesus while building lasting friendships.', times: ['Friday Youth Group · 6:30 PM', 'Sunday School · 9:50 AM', 'Summer Mission Trip · July'] },
  { Icon: Music2, title: 'Worship Ministry', leader: 'Sarah Williams', img: worshipBg, desc: 'Leading the congregation in lifting praise to God through music, song, and creative expression.', times: ['Choir Practice · Wed 6:00 PM', 'Team Rehearsal · Sat 10:00 AM', 'A/V Team · Sunday mornings'] },
  { Icon: Baby, title: "Children's Ministry", leader: 'Jennifer Martinez', img: bibleStudyBg, desc: 'Partnering with parents to introduce children to Jesus from infancy through elementary school.', times: ['Sunday School · 9:50 AM', "Children's Church · During service", 'Vacation Bible School · Summer'] },
  { Icon: HandHeart, title: 'Outreach Ministry', leader: 'Deacon James Parker', img: prayerBg, desc: 'Being the hands and feet of Jesus — serving those in need and sharing the Gospel through action.', times: ['Food Pantry · 2nd Saturday', 'Prison Ministry · Monthly', 'Senior Care Visits · Ongoing'] },
];

const ACCENTS = ['burgundy', 'navy', 'tan', 'burgundy'];

function Ministries() {
  return (
    <main>
      <PageHero eyebrow="Get Involved" title="Our Ministries" subtitle="Find your place to serve and grow." image={ministrytile} />

      <section className="ds-section-y" style={{ background: 'var(--cream)', padding: 'var(--section-y) var(--gutter)' }}>
        <div className="ds-grid-2" style={{ maxWidth: 'var(--maxw)', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '34px' }}>
          {MINISTRIES.map((m, i) => (
            <Reveal key={m.title} delay={(i % 2) * 90}>
              <Card accent={ACCENTS[i]} media={<CardMedia image={m.img} height="220px" />} padding="38px" style={{ height: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ width: '52px', height: '52px', flex: 'none', borderRadius: 'var(--radius-md)', background: 'var(--gradient-brand)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <m.Icon size={24} />
                  </div>
                  <div>
                    <h3 className="v2-serif" style={{ fontSize: '27px', color: 'var(--navy-800)', margin: 0, lineHeight: 1.12 }}>{m.title}</h3>
                    <div style={{ fontFamily: 'var(--font-ui)', fontSize: '14px', color: 'var(--burgundy-700)', fontWeight: 600 }}>Led by {m.leader}</div>
                  </div>
                </div>
                <p style={{ fontFamily: 'var(--font-ui)', fontSize: '15.5px', color: 'var(--text-body)', lineHeight: 1.75, margin: '0 0 18px' }}>{m.desc}</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {m.times.map((t) => <Badge key={t} tone="navy" soft>{t}</Badge>)}
                </div>
              </Card>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}

export default Ministries;
